import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CircularProgress from '@mui/material/CircularProgress';

function Received() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const [totalrent, setRent] = useState(0);
    const [totalpaid, setPaid] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isFocused, setIsFocused] = useState(false); //for search

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        // Calculate total 
        let totalrent = 0;
        let totalpaid = 0;


        dataItem.forEach(item => {
            totalrent += item.RentAmount;
            totalpaid += item.PaidAmount;
        });
        setRent(totalrent);
        setPaid(totalpaid);
    }, [dataItem]);

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        const customerId = selectedOption ? selectedOption.value : '';
        setCustomer(customerId);
        setDataItem([])
    };


    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('ReportApi', `/Customer/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.ID,
                }));
                setCustomerOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([])
            setLoading(true);
            try {
                const response = await fetchData('ReportApi', `/Received/${companyId}/${customerId}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);

                }
            } catch (error) {
                console.error('Error fetching Packing Slip Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            };
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const excelData = [];

        // Add header row
        const headerCaption = [`Received Rent Report From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        excelData.push(headerCaption);
        const headerRow = ['Sl.No', 'Bill No', 'Bill Date', 'Customer Name', 'Contact', 'Room', 'Rent', 'Paid'];
        excelData.push(headerRow);

        // Add data rows
        filteredDataItem.forEach((rowData, index) => {
            const dataRow = [
                index + 1,
                rowData.BillNo,
                formatDate(rowData.BillDate),
                rowData.CustomerName,
                `${rowData.ContactNumber1} , ${rowData.ContactNumber2}`,
                rowData.RoomName,
                rowData.RentAmount,
                rowData.PaidAmount,

            ];
            excelData.push(dataRow);
        });

        const totalRow = ['', '', '', '', '', '', totalrent, totalpaid];
        excelData.push(totalRow);

        // Create worksheet and workbook
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Received Rent Report');

        // Set column widths
        const wsCols = [
            { wch: 8 },  // Sl.No
            { wch: 15 }, // Bill No
            { wch: 15 }, // Bill Date
            { wch: 25 }, // Customer Name
            { wch: 30 }, // Contact
            { wch: 15 }, // Room
            { wch: 10 }, // Rent
            { wch: 10 }, // Paid

        ];
        ws['!cols'] = wsCols;

        // Export to Excel
        XLSX.writeFile(wb, 'Received Rent Report.xlsx');
    };



    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            console.error('Failed to open print window.');
            return;
        }

        printWindow.document.write('<html><head><title>Rent Received Report</title></head><body>');

        // Create title including date range
        const title = `Rent Received Report`;
        printWindow.document.write('<html><head><title>' + title + '</title></head><body>');
        printWindow.document.write(`<h4 style="font-family: Times New Roman; font-size: 22px;">Rent Received Report From: ${formatDate(fromDate)} To: ${formatDate(toDate)}</h4>`);

        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bill No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bill Date</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Customer Name</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Contact</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Room</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Rent</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Paid</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        filteredDataItem.forEach((rowData, index) => {
            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${index + 1}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.BillNo}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${formatDate(rowData.BillDate)}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.CustomerName}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.ContactNumber1} , ${rowData.ContactNumber2}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.RoomName}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align :right;">${rowData.RentAmount}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align :right;">${rowData.PaidAmount}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody>');
        printWindow.document.write('</table>');
        printWindow.document.write('</body></html>');

        printWindow.document.close();
        printWindow.print();
    };



    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '97%' }}>

            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>

                <h6 style={{ flexGrow: 1, color: 'linkColor', fontFamily: 'Times New Roman', whiteSpace: 'nowrap', marginRight: '8px' }}>
                    RECEIVED
                </h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <div style={{ marginTop: '20px', gap: '10px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '300px' : '200px',
                            height: '40px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label style={{ display: 'block', color: 'gray', fontSize: '16px', fontWeight: 'bold', marginBottom: '2' }} htmlFor="fromDate">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label style={{ display: 'block', color: 'gray', fontSize: '16px', fontWeight: 'bold', marginBottom: '2' }} htmlFor="toDate">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                <Button
                    style={{
                        marginRight: '8px',
                        background: 'linear-gradient(to right, darkslategray, slategray)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        marginTop: '15px',
                        marginLeft: '10px'

                    }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >
                    <IconButton onClick={fetchTableData}>
                        <RefreshIcon style={{ color: 'white' }} />
                    </IconButton>
                    Refresh
                </Button>

                <Button
                    style={{
                        marginRight: '8px',
                        background: 'linear-gradient(to right, darkslategray, slategray)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        marginTop: '15px'

                    }}
                    onClick={handleExportExcel}
                    className="linkcolor"
                >
                    <IconButton onClick={handleExportExcel}>
                        <FeedIcon style={{ color: 'white' }} />
                    </IconButton>
                    Excel
                </Button>

                <Button
                    style={{
                        marginRight: '8px',
                        background: 'linear-gradient(to right, darkslategray, slategray)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: 'white',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        marginTop: '15px'

                    }}
                    onClick={handlePrint}
                    className="linkcolor"
                >
                    <IconButton onClick={handlePrint}>
                        <FeedIcon style={{ color: 'white' }} />
                    </IconButton>
                    Print
                </Button>

            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto', marginTop: '5px' }}>

                <TableContainer component={Paper}>
                    {/* <Table> */}
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '100%' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', padding: '5px', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', padding: '5px', textTransform: 'uppercase' }}>Bill No</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', padding: '5px', textTransform: 'uppercase' }}>Bill Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', padding: '5px', textTransform: 'uppercase' }}>Customer</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', padding: '5px', textTransform: 'uppercase' }}>Contact</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', padding: '5px', textTransform: 'uppercase' }}>Room</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', textAlign: 'center', padding: '5px', textTransform: 'uppercase' }}>Rent</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #ddd', fontSize: '12px', fontWeight: 'bolder', color: 'whitesmoke', textAlign: 'center', padding: '5px', textTransform: 'uppercase' }}>Paid</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', fontWeight: 'bolder', color: 'whitesmoke', textAlign: 'center' }}>Received In Days</TableCell> */}
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem && filteredDataItem.length > 0 && (
                                filteredDataItem.map((item, index) => (
                                    <TableRow key={index}>

                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'left' }}>
                                            {index + 1}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'left' }}>
                                            {item.BillNo}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: '1px solid #000000',
                                                borderRight: '1px solid #000000',
                                                color: 'black',
                                                fontWeight: 'bold',
                                                padding: '5px',
                                                fontSize: '12px',
                                                textAlign: 'left'
                                            }}
                                        >
                                            {new Date(item.BillDate).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'long',
                                                year: 'numeric'
                                            }).replace(/\s/g, '/')}
                                        </TableCell>

                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'left' }}>
                                            {item.CustomerName}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'left' }}>
                                            {item.ContactNumber1} ,  {item.ContactNumber2}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'left' }}>
                                            {item.RoomName}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'right' }}>
                                            {item.RentAmount}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'right' }}>
                                            {item.PaidAmount}
                                        </TableCell>
                                        {/* <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                                            {item.ReceivedDays}
                                        </TableCell> */}
                                    </TableRow>
                                ))
                            )}
                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '5px',
                                    backgroundColor: 'teal',
                                }}
                            >
                                <TableCell colSpan={6} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{totalrent.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', fontSize: '12px', textAlign: 'right' }}>{totalpaid.toFixed(2)}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default Received;

